(function () {
  'use strict';

  // ── Favoritos / Wishlist ──────────────────────────────────────
  var WISHLIST_KEY = 'bp_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function showToast(msg) {
    var toast = document.querySelector('.bp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('bp-toast--on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('bp-toast--on'); }, 2600);
  }

  function initWishlist() {
    var btn = document.querySelector('a[href="#wishlist"]');
    if (!btn) return;

    // Identificar el producto por handle (URL)
    var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';

    function refresh() {
      var active = handle && getWishlist().indexOf(handle) > -1;
      btn.innerHTML = active
        ? '<span>♥  En tus favoritos</span>'
        : '<span>♡  Agregar a favoritos</span>';
      btn.classList.toggle('bp-fav-active', active);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!handle) return;
      var list = getWishlist();
      var idx  = list.indexOf(handle);
      if (idx > -1) {
        list.splice(idx, 1);
        showToast('Eliminado de favoritos');
      } else {
        list.push(handle);
        showToast('🐾 Guardado en favoritos');
      }
      saveWishlist(list);
      refresh();
    });

    refresh();
  }

  // ── Init ─────────────────────────────────────────────────────
  function init() {
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
